import * as React     from 'react';
import styled         from 'styled-components';
import { Button }     from '@components/index';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import { IAddress }   from '@utils/useDecodeZipCode';
import {
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogContentText,
  DialogActions as MuiDialogActions,
  withWidth,
}                     from '@material-ui/core';

interface IProps {
  address   : IAddress;
  width     : Breakpoint;
  open      : boolean;
  onClose   : () => void;
  onAgree   : (props?: any) => void;
  onDiscard : (props?: any) => void;
}

const DialogTitle = styled(MuiDialogTitle)`
  && {
    background-color: ${({ theme: { backgroundColor } }): string => backgroundColor.darkBlue};

    h2 {
      font-weight: 300;
      color: ${({ theme: { textColor } }): string => textColor.white};
    }
  }
`;

const DialogContent = styled(MuiDialogContent)`
  && {
    padding: 20px 40px 0;

    p {
      color: ${({ theme: { textColor } }): string => textColor.black};
    }

    span {
      font-size   : 16px;
      font-weight : 500;
    }
  }
`;

const DialogActions = styled(MuiDialogActions)`
  && {
    display : flex;
    padding : 20px;

    @media (max-width: 600px) {
      flex-wrap: wrap;
    }
  }
`;

const addressString = (address: IAddress): string =>
  `${address.city ? `${address.city},` : ''} ${address.state ?? ''} ${address.zip ?? ''}`.trim();

const AddressModalComponent: React.FC<IProps> = ({
  address,
  width,
  open,
  onClose,
  onAgree,
  onDiscard,
}: IProps): JSX.Element => (
  <>
    <Dialog
      open       = {open}
      onClose    = {onClose}
      maxWidth   = "xs"
      PaperProps = {{
        style: {
          padding      : 0,
          borderRadius : 5,
        },
      }}
    >
      <DialogTitle>
        Confirm Address
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          Our records indicate the city and state you entered
          does not match the zip code. Do you want to use the
          city and state we have on file?
        </DialogContentText>
        <span>{addressString(address)}</span>
      </DialogContent>

      <DialogActions disableSpacing>
        <Button
          variant = "outlined"
          label   = "Continue with Existing Address"
          onClick = {onDiscard}
          fullWidth
        />

        <Button
          label     = "Yes"
          width     = "80px"
          onClick   = {onAgree}
          fullWidth = {width === 'xs'}
        />
      </DialogActions>
    </Dialog>
  </>
);

export const AddressModal = withWidth()(AddressModalComponent);
